import {Button, Col, DatePicker, Form, Input, InputNumber, Row} from 'antd';
import React, {useEffect, useState} from 'react';
import {Arguments} from '../common/Arguments';
import {DateTimeToMoment} from '../common/MomentDateTimeConverter';
import {GetOrgData} from '../common/ApiMethod';
import OnFinishMethod from '../common/OnFinishMethod';
import {validateWhiteSpace} from '../common/ValidateWhiteSpace';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const BasicInformationAdmin = () => {
	const [currentRecord, setCurrentRecord] = useState([]);
	const [saveButton, setSaveButton] = useState(false);
	const [form] = Form.useForm();
	const postApi = [Arguments.host + '/society_organization/party/consortium/api!addBasicInformation.do'];
	const getApi = Arguments.host + '/society_organization/party/consortium/api!basicInformation.do';
	const orgId = (parseInt(sessionStorage.getItem('coffee')) / 20).toString();

	useEffect(() => {
		GetOrgData(getApi).then(finalResult => {
			setCurrentRecord({organizationId: orgId, ...finalResult});
			form.setFieldsValue(Object.keys(finalResult).length > 0 ? DateTimeToMoment(finalResult) : finalResult);
		});
	}, [getApi]);

	const onFinish = (data) => {
		OnFinishMethod({...currentRecord, ...data}, postApi);
		setTimeout(() => setSaveButton(true), 500);
	};

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={onFinish}
			style={{maxWidth: 800, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="branchName" label="支部名称"
						rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="branchEstablishDate" label="成立日期"
							   rules={[{required: true, message: '内容不能为空'}]}>
						<DatePicker placeholder="选择日期"/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name="branchTermDate"
						label="换届日期"
						rules={[{required: true, message: '内容不能为空'}]}
					>
						<DatePicker placeholder="选择日期"/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="branchTermYear" label="换届年限"
						rules={[{required: true, message: '内容不能为空'}]}>
						<InputNumber min={0} style={{width: 150}}/>
					</Form.Item>
				</Col>
			</Row>


			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="membership" label="隶属关系" rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit" disabled={saveButton}>
					保存
				</Button>
			</Form.Item>
		</Form>
	);
};

export default BasicInformationAdmin;
